import React, { useState, useRef } from "react";
import StickyHeader from "../../../../components/ModuleCommon/StickyHeader/StickyHeader";
import Loader from "../../../../components/ACS-Dashboard/ACS-Blocks/Loader";
import Button from "../../../../components/ACS-Dashboard/ACS-Blocks/Button";
import axios from "axios";
import { UploadCloud, FileQuestion } from "lucide-react"

const CreateUploadDocumentTab = ({ setActiveTab, tabs }) => {
  const headerRef = useRef(null);
  const [isTemplateSaved, setIsTemplateSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);
  const [file, setFile] = useState(null);

  const [parsedInfo, setParsedInfo] = useState({
    SCAC: "",
    ProNumber: "",
    FreightTerms: "",
    Selection: "",
    MasterBOL: "",
    TrailerName: "",
    SealNumber: ""
  });

  const handleFileUpload = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);

    // Mock parsing result
    setParsedInfo({
      SCAC: "SCAC123",
      ProNumber: "PRO-9876",
      FreightTerms: "Freight prepaid unless marked otherwise",
      Selection: "Standard",
      MasterBOL: "Master bill with underlying",
      TrailerName: "Trailer XYZ",
      SealNumber: "Seal-5555"
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);

      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/documents/upload`, formData);

      alert("Document uploaded successfully!");
    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload failed.");
    } finally {
      setLoading(false);
    }
  };

  const buttons = [
    { label: "Submit", type: "primary", color: "green", onClick: handleSubmit },
    { label: "Delete", type: "default", color: "red", onClick: () => setFile(null) },
  ];
  

  const infoData = {
    "Ascend Cargo Score": { type: "badge", value: "" },
    "Status": { type: "badge", value: "" },
    "PO Number": { type: "text", value: "" },
    "Shipment Number": { type: "text", value: "" },
    "Document Name": { type: "text", value: "" }
  };

  const templates = ["Default Template"];

  return (
    <div className={`w-full h-full min-h-0 flex flex-col transition-opacity duration-500 ${fadeOut ? "opacity-0" : "opacity-100"}`}>
        <>
          {/* Sticky Header */}
          <div ref={headerRef} className="sticky  top-0 z-10 bg-white shadow-md w-full">
            <StickyHeader
              infoData={infoData}
              onInfoChange={() => {}}
              templates={templates}
              onSelectTemplate={() => {}}
              buttons={buttons}
              saveTemplateConfig={{
                checked: isTemplateSaved,
                onChange: () => setIsTemplateSaved((prev) => !prev),
              }}
              mode="dataExport"
              handleExportData={() => {
              }}
            />
          </div>

          {/* Main Content */}
          <div className="flex-1 overflow-y-auto bg-white w-full p-fluid-1">
            <div className="bg-white [clamp(0.75rem,1vw,1.5rem)] shadow-fluid-card p-fluid-2">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                {/* Left Upload Section */}
                <div className="flex flex-col gap-fluid-2">
                <h2 className="text-fluid-3xl font-bold mb-fluid-1">Original Document</h2>
                  <div className="p-fluid-2 [clamp(0.75rem,1vw,1rem)] flex items-center justify-center h-[372px] shadow-[0_0_12px_rgba(0,0,0,0.10)]">
                    {!file ? (
                      <label className="cursor-pointer text-center">
                        <input
                          type="file"
                          className="hidden"
                          onChange={handleFileUpload}
                          accept=".pdf,.doc,.docx,.jpg,.png"
                        />
                       <div className="bg-[#223688] hover:bg-[#1b2d6b] transition-colors text-white rounded-full px-fluid-3 py-fluid-2 flex items-center justify-center gap-fluid-1 text-fluid-base font-semibold shadow-md cursor-pointer">
                          <UploadCloud size={22} className="text-white" />
                          <span className="text-fluid-3xl">Upload a Bill of Lading</span>
                        </div>
                      </label>
                    ) : (
                      <div className="flex flex-col items-center gap-fluid-2">
                        <p className="font-semibold text-fluid-md">{file.name}</p>
                        <Button
                          text="Change File"
                          onClick={() => setFile(null)}
                          backgroundColor="#223688"
                          textColor="white"
                        />
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Parsed Section */}
                <div className="flex flex-col gap-fluid-2">
                <h2 className="text-fluid-3xl font-bold mb-fluid-1">Parsed Information</h2>
                <div className="overflow-x-auto rounded-lg border border-gray-200">
                  <table className="min-w-full text-fluid-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="text-left px-4 py-2 font-semibold">Bill of Lading</th>
                        <th className="text-left px-4 py-2 font-semibold">Carrier Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-t">
                        <td className="px-4 py-2 text-gray-700">SCAC: {parsedInfo.SCAC}</td>
                        <td className="px-4 py-2 text-gray-700">Trailer Name: {parsedInfo.TrailerName}</td>
                      </tr>
                      <tr className="border-t">
                        <td className="px-4 py-2 text-gray-700">Pro Number: {parsedInfo.ProNumber}</td>
                        <td className="px-4 py-2 text-gray-700">Seal Number: {parsedInfo.SealNumber}</td>
                      </tr>
                      <tr className="border-t">
                        <td className="px-4 py-2 text-gray-700">Freight Terms: {parsedInfo.FreightTerms}</td>
                        <td className="px-4 py-2 text-gray-700"></td>
                      </tr>
                      <tr className="border-t">
                        <td className="px-4 py-2 text-gray-700">Selection: {parsedInfo.Selection}</td>
                        <td className="px-4 py-2 text-gray-700"></td>
                      </tr>
                      <tr className="border-t">
                        <td className="px-4 py-2 text-gray-700">Master BOL: {parsedInfo.MasterBOL}</td>
                        <td className="px-4 py-2 text-gray-700"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </div>
              </div>

              {/* Document History */}

              <div className="border p-fluid-2 [clamp(0.75rem,1vw,1rem)] bg-white">
                <div className="flex items-center gap-fluid-1">
                  <h2 className="text-fluid-3xl font-bold text-[#030229] mb-fluid-1">Document History</h2>
                  
                  {/* FileQuestion Icon */}
                  <FileQuestion size={24} className="text-[#030229]" />
                </div>
              </div>


            </div>
          </div>
        </>
    </div>
  );
};

export default CreateUploadDocumentTab;
